import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import i18n from '@/locales'

export type LocaleType = 'zh-CN' | 'en-US'

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<LocaleType>((localStorage.getItem('locale') as LocaleType) || 'zh-CN')

  function setLocale(val: LocaleType) {
    locale.value = val
  }

  watch(locale, (val) => {
    localStorage.setItem('locale', val)
    i18n.global.locale.value = val
    // Refresh menu translations when locale changes
    import('./menu').then(({ useMenuStore }) => {
      useMenuStore().refreshMenuTranslations()
    })
  })

  // 初始化同步
  i18n.global.locale.value = locale.value

  return {
    locale,
    setLocale
  }
})
